import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { LoginV1 } from './login-v1';
import { LoginV2 } from './login-v2';

type LoginProps = {
  hideIfNeitherEnabled?: boolean;
  margin?: string;
};

export const Login = ({ hideIfNeitherEnabled = false, margin }: LoginProps): JSX.Element => {
  const flags = useFlags();
  const isLoyaltyPersonalizationCtaEnabled =
    flags['growth.ecomm.logged-out-loyalty-personalization-cta.rollout'] ?? false;

  return isLoyaltyPersonalizationCtaEnabled ? (
    <LoginV2 hideIfNeitherEnabled={hideIfNeitherEnabled} margin={margin} />
  ) : (
    <LoginV1 />
  );
};
